import { ServiceOrderStatus } from '@bhops/shared';

// plan-field-service-orders.md §F-6 — client-side mirror of the
// API's locked transition matrix. Used by the inbox detail rail
// to render "available actions" buttons. The server is the
// authority — every transition still goes through
// POST /service-orders/:id/transitions and the API enforces the
// matrix again — but pre-filtering on the client keeps the UI
// from offering moves that will only ever 400.
//
// Keep this in sync with apps/api/src/service-orders/state-machine.ts.
// If they ever drift, the API wins (UI button just disables itself
// after the 400 propagates as a toast).

const ALLOWED_TRANSITIONS: Readonly<Record<ServiceOrderStatus, ReadonlyArray<ServiceOrderStatus>>> =
  {
    [ServiceOrderStatus.OPEN]: [ServiceOrderStatus.TRIAGED, ServiceOrderStatus.CANCELLED],
    [ServiceOrderStatus.TRIAGED]: [ServiceOrderStatus.ASSIGNED, ServiceOrderStatus.CANCELLED],
    [ServiceOrderStatus.ASSIGNED]: [
      ServiceOrderStatus.IN_PROGRESS,
      ServiceOrderStatus.BLOCKED,
      ServiceOrderStatus.CANCELLED,
    ],
    [ServiceOrderStatus.IN_PROGRESS]: [
      ServiceOrderStatus.BLOCKED,
      ServiceOrderStatus.RESOLVED,
      ServiceOrderStatus.CANCELLED,
    ],
    [ServiceOrderStatus.BLOCKED]: [ServiceOrderStatus.IN_PROGRESS, ServiceOrderStatus.CANCELLED],
    [ServiceOrderStatus.RESOLVED]: [ServiceOrderStatus.VERIFIED, ServiceOrderStatus.IN_PROGRESS],
    [ServiceOrderStatus.VERIFIED]: [ServiceOrderStatus.CLOSED, ServiceOrderStatus.IN_PROGRESS],
    [ServiceOrderStatus.CLOSED]: [],
    [ServiceOrderStatus.CANCELLED]: [],
  };

export function allowedNextStatuses(from: ServiceOrderStatus): ServiceOrderStatus[] {
  return [...ALLOWED_TRANSITIONS[from]];
}

export function isTerminalStatus(status: ServiceOrderStatus): boolean {
  return ALLOWED_TRANSITIONS[status].length === 0;
}
